import { render, staticRenderFns } from "./LocationsList.vue?vue&type=template&id=28eff68c&scoped=true&"
import script from "./LocationsList.vue?vue&type=script&lang=js&"
export * from "./LocationsList.vue?vue&type=script&lang=js&"
import style0 from "./LocationsList.vue?vue&type=style&index=0&id=28eff68c&lang=scss&scoped=true&"
import style1 from "./LocationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eff68c",
  null
  
)

export default component.exports